<template>
    <div id="home">
        <div class="title">
            <div class="head1">
                <!-- <img src="../assets/head.png" alt=""> -->
                <span>{{home.account.name.slice(0,1)}}</span>
            </div>
            <div class="head2">
                <p class="name">
                    <span class="t">{{home.account.name}}</span>
                    <!-- <van-button type="primary" size="mini" @click="logout">注销</van-button> -->
                </p>
                <p>
                    <span :class="{'ellipsis':!showTitle}" @click="showTitle = !showTitle">{{home.account.simpleCompanyName}}</span>
                    <van-button type="primary" size="mini" @click="popupVisible = true">切换</van-button>
                </p>
            </div>
        </div>
        <div class="card">
            <div class="t">
                <i class="iconfont iconbookmark"></i> 管理信息
            </div>
            <!-- <van-grid column-num="1">
            <van-grid-item icon="photo-o" >
                <div>床位数</div>
                <div>{{  home.arrears?'￥'+home.arrears :'0'}}</div>
            </van-grid-item>
           
            </van-grid>
             <van-grid >
            <van-grid-item icon="photo-o" text="床位数" />
              
        
            <van-grid-item icon="photo-o" text="床位数" />
            <van-grid-item icon="photo-o" text="房间满租率" />
            <van-grid-item icon="photo-o" text="床位满租率" />
            </van-grid> -->
            <div class="content nowarp">
                <div class="inlineB inline-top">
                    <div class=" l">房源数</div>
                     <div class="flex">
                          <!-- <p class="l">房间 | 床位</p> -->
                       <div class="title_data top">
                            <div  class="s_title left_title ">
                                房间 
                            </div>
                              <div class="s_title left_title colorY">
                                {{home.manageNum?home.manageNum:'0'}} 
                            </div>
                            
                       </div>
                          <!-- <p class="l">房间 | 床位</p> -->
                       <div class="title_data bottom ">
                          <div class="s_title right_title">
                                 床位
                            </div>
                            <!-- <div class="s_title middle "> | </div> -->
                              <div class="s_title right_title colorY">
                               {{home.manageBedNum?home.manageBedNum:'0'}}
                            </div>
                       </div>
                     </div>
                    <!-- <p class="l">{{home.manageNum?home.manageNum:'0'}} | {{home.manageBedNum?home.manageBedNum:'0'}}</p> -->
                </div>
                <!-- <span class="line"></span> -->
                  <div class="inlineB inline-top">
                    <div class=" l">满租率</div>
                     <div class="flex">
                          <!-- <p class="l">房间 | 床位</p> -->
                       <div class="title_data top">
                            <div  class="s_title left_title ">
                                房间 
                            </div>
                              <div class="s_title left_title colorY">
                                {{home.fullRentRate?accMul(home.fullRentRate,100) + '%':'0%'}}
                            </div>
                            
                       </div>
                          <!-- <p class="l">房间 | 床位</p> -->
                       <div class="title_data bottom ">
                          <div class="s_title right_title">
                                 床位
                            </div>
                            <!-- <div class="s_title middle "> | </div> -->
                              <div class="s_title right_title colorY">
                               {{home.bedFullRentRate?accMul(home.bedFullRentRate,100) + '%':'0%'}}
                            </div>
                       </div>
                     </div>
                    <!-- <p class="l">{{home.manageNum?home.manageNum:'0'}} | {{home.manageBedNum?home.manageBedNum:'0'}}</p> -->
                </div>
             
                <!-- <span class="line"></span> -->
                <div class="inlineB inline-top" style="align-self: baseline;">
                    <div class=" l">催收款</div>
                     
                    <div style="    align-items: center;"  class="colorY flex">{{  home.arrears?'￥'+home.arrears :'0'}}</div>
                </div>
            </div>
        </div>
        <div class="card">
            <div class="t">
                <i class="iconfont iconxiaoxi"></i> 消息中心
            </div>
            <div class="content">
                <div class="inlineB" @click="$router.push({path:'/myschedule',query:{type:'2'}})">
                    <div class="box" :class="{'yellow':home.unReadCount.waitingUnReadCount}">{{home.unReadCount.waitingUnReadCount?home.unReadCount.waitingUnReadCount:'0'}}</div>
                    <p class="pt">我的待办</p>
                </div>
                <div class="inlineB" @click="$router.push({path:'/myschedule',query:{type:'1'}})">
                    <div class="box">-</div>
                    <p class="pt">我发起的</p>
                </div>
                <div class="inlineB" @click="$router.push({path:'/myschedule',query:{type:'3'}})">
                    <div class="box">-</div>
                    <p class="pt">我参与的</p>
                </div>
            </div>
        </div>
        <div class="card">
            <div class="t">
                <i class="iconfont icongongzuoshi"></i> 工作台
            </div>
            <div class="content">
                <div v-for="item in menuTree" :key="item.path" class="inlineB" @click="$router.push('/'+item.path)">
                    <div class="box">
                        <i :class="'iconfont '+ iconList[item.path]"></i>
                    </div>
                    <p class="pt">{{item.title}}</p>
                </div>
                <!-- <div class="inlineB" @click="$router.push('/customerList')">
                    <div class="box">
                        <van-icon name="friends" />
                    </div>
                    <p class="pt">客户管理</p>
                </div>
                <div class="inlineB" @click="$router.push('/destineList')">
                    <div class="box">
                        <i class="iconfont icondingdan"></i>
                    </div>
                    <p class="pt">预订单</p>
                </div>
                <div class="inlineB">
                    <div class="box" @click="$router.push('/contractList')">
                        <i class="iconfont iconqianyue"></i>
                    </div>
                    <p class="pt">租房合约</p>
                </div>
                <div class="inlineB">
                    <div class="box" @click="$router.push('/orderList')">
                        <i class="iconfont iconqiankuan2"></i>
                    </div>
                    <p class="pt">欠款列表</p>
                </div>
                <div class="inlineB">
                    <div class="box" @click="$router.push('/roomList')">
                        <i class="iconfont iconchazhaofangyuan"></i>
                    </div>
                    <p class="pt">房间管理</p>
                </div> -->
                <!-- <div class="inlineB">
                    <div class="box">
                        <i class="iconfont iconrizhiguanli"></i>
                    </div>
                    <p class="pt">日报管理</p>
                </div> -->
            </div>
        </div>
        <van-popup v-model="popupVisible" position="bottom" class="popup">
            <van-picker show-toolbar :columns="slotsCompany" valueKey="simpleName" @cancel="popupVisible = false" @confirm="changeCompany" />
        </van-popup>
    </div>
</template>

<script>
import {
    requestCompany,
    requestHome,
    changeCompany,
    requestMenuTree,
    requestButtomAuth,
} from "@/api";
import { mapState } from "vuex";
import { setUser, getUser, removeToken, removeUser } from "@/utils/auth";
import { accMul } from "@/utils";
export default {
    name: "home",
    data() {
        return {
            popupVisible: false,
            showTitle: false,
            slotsCompany: [],
            nowCompany: {
                name: "南京银城千万间公寓公司",
                id: "",
            },
            home: {
                account: {
                    name: "",
                }, //用户基本信息
                arrears: "", //欠款
                companyList: [], //当前登录人公司下拉
                fullRentRate: "", //满租率
                manageNum: "", //管理间数
                unReadCount: {
                    waitingUnReadCount: "", //我的待办
                    involvedUnReadCount: "", //我参与的
                },
            },
            menuTree: [],
            iconList: {
                customerList: "iconfriends",
                destineList: "icondingdan",
                contractList: "iconqianyue",
                orderList: "iconqiankuan2",
                roomList: "iconchazhaofangyuan",
                propertyList: "iconyezhu",
                fssContractList: "iconshoufangheyue",
                workOrderList: "icongongdan",
                reportList: "icontianxieribao",
                jointOrderAList:"iconicon-class-a"
            },
        };
    },
    computed: {},
    created() {
        // this.getCompany();

        this.getHome();
    },
    mounted() {},
    methods: {
        getCompany() {
            requestCompany().then((res) => {
                this.slotsCompany = res.data;
            }).catch(err={
                
            });
        },
        //获取首页信息
        getHome() {
            const toast1 = this.$toast.loading({
                forbidClick: true,
                duration: 0,
                message: "加载中...",
            });
            requestHome()
                .then((res) => {
                    this.slotsCompany = res.data.companyList;
                    res.data.unReadCount = res.data.unReadCount || {};
                    this.home = res.data;
                    setUser(res.data.account);
                    this.$store.commit("SET_USER", res.data.account);
                    //
                    this.getMenuTree();
                    toast1.clear();
                })
                .catch((err) => {
                    toast1.clear();
                });
        },
        //获取首页菜单权限
        getMenuTree() {
            const toast1 = this.$toast.loading({
                forbidClick: true,
                duration: 0,
                message: "加载中...",
            });
            requestMenuTree()
                .then((res) => {
                    res.data = res.data || [];
                    res.data = res.data.sort((a, b) => a.sort - b.sort);
                    this.menuTree = res.data;
                    toast1.clear();
                })
                .catch((err) => {
                    toast1.clear();
                });
        },
        changeCompany(val) {
            this.$dialog.confirm({
                title: "提示",
                message: "切换到" + val.simpleName + "？",
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                beforeClose: (action, done) => {
                    if (action === "confirm") {
                        changeCompany({ companyId: val.id })
                            .then((res) => {
                                this.$store
                                    .dispatch("resetAll", res.data)
                                    .then((res) => {
                                        this.getHome();
                                        this.popupVisible = false;
                                        done();
                                    });
                                requestButtomAuth().then((res) => {
                                    this.$store.commit(
                                        "SET_BUTTON",
                                        res.data || []
                                    );
                                });
                            })
                            .catch((err) => {
                                done(false);
                                console.log(err);
                            });
                    } else {
                        done();
                    }
                },
            });
        },
        //注销
        logout() {
            this.$dialog.confirm({
                title: "提示",
                message: "退出当前用户？",
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                beforeClose: (action, done) => {
                    if (action === "confirm") {
                        removeToken();
                        removeUser();
                        this.$router.push(`/login`);
                        done();
                    } else {
                        done();
                    }
                },
            });
        },
        accMul(num1, num2) {
            return accMul(num1, num2);
        },
    },
    watch: {},
};
</script>
<style lang="scss" scoped>
@import "../common/scss/variable.scss";
#home {
    font-size: 0.35rem;
    // position: fixed;
    width: 100%;
    .colorC {
        color: $colorC;
    }
    .title {
        // height: 1rem;
        display: flex;
        text-align: left;
        line-height: 0.8rem;
        border-bottom: 1px solid $border-color;
        background-color: #fff;
        padding: 0.3rem 0.7rem;
        font-size: 0.32rem;
        .head1 {
            width: 1.5rem;
            height: 1.5rem;
            line-height: 1.5rem;
            text-align: center;
            font-size: 0.6rem;
            font-weight: 600;
            border-radius: 2rem;
            color: #fff;
            background-color: $theme-color;
            margin-right: 0.3rem;
            img {
                width: 100%;
            }
        }
        .head2 {
            flex: 1;
        }
        p {
            display: flex;
            justify-content: space-between;
            align-items: center;
            // > span {
            //     font-size: 0.4rem;
            // }
        }
        .name {
            .t {
                font-size: 0.4rem;
                font-weight: 600;
            }
        }
        .line {
            height: 60%;
            border-right: 1px solid #717171;
            margin: 0 0.2rem;
        }
        .ellipsis {
            max-width: 8.5rem;
            vertical-align: top;
            overflow: hidden;
            display: inline-block;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
    }
    .card {
        // margin: 0.3rem 0;
        .t {
            text-align: left;
            font-size: 0.4rem;
            font-weight: 600;
            padding: 0.2rem 0 0.2rem 0.2rem;
            i {
                // color: $theme-color;
            }
        }
        .content {
            background-color: #fff;
            display: flex;
            // border-radius: 0.2rem;
            align-items: center;
            justify-content: flex-start;
            flex-wrap: wrap;
            // padding-bottom: 0.1rem;
            &.nowarp {
                flex-wrap: nowrap;
            }
            .inlineB {
                // flex: 1;
                // margin-top:0.3rem;
                margin: 0.25rem 0 0.25rem 0;
               
                width: 33.3%;
                min-width: 33.3%;
                max-width: 33.3%;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                .title_data{
                    width: 100%;
                 
                    font-size:12px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                }
                .flex{
                     width: 100%;
                    display: flex;
                    flex-direction: row;
                    justify-content: center;
                        // padding: 0.2rem 0;
                        height: 1.5rem;
                }
                .colorY{
                    color: #fd7e2d;
                }
                .top{
                    display: flex;
                    flex-direction: column;
                    width:50%;
                    font-size:12px;
                       border-right: 0.02667rem solid #ccc;
                 
                }
                 .bottom{
                      display: flex;
                    flex-direction: column;
                     width:50%;
                    // margin: 0.15rem 0 0.15rem 0
                }
                .middle{
                    width:5%;
                    margin: 0 5px ;
                }
                 .s_title{
               
                    box-sizing: border-box;
                }
                .left_title{
                  
                  padding: 0.1rem 0 0.1rem 0;
                    
                }
                .right_title{
               
                 padding: 0.1rem 0 0.1rem 0;

                 
                   
                }
               
                .border-right{
                    // border-right: 1px solid;
                }
                div.l {
                    // line-height: 1rem;
                    font-size:0.32rem;
                    width: 100%;
                    text-align: center;;
                    border-bottom:1px solid #ccc;
                    padding: 0.2rem;
                    color: #666666
                }
                div.l {
                  
                }
                .box {
                    width: 1rem;
                    height: 1rem;
                    line-height: 1rem;
                    border: 1px solid #ccc;
                    margin: 0.2rem auto 0;
                    border-radius: 0.2rem;
                    i {
                        font-size: 0.7rem;
                        line-height: 1rem;
                        color: $theme-color;
                    }
                    &.yellow {
                       color: #fd7e2d;
                    }
                }
                p.pt {
                    padding-top: 0.2rem;
                }
            }
            .inline-top{
                 border-right: 1px solid #ccc;
                  margin: 0rem 0 0 0;
            }
            .line {
                height: 1.7rem;
                border-right: 1px solid #ccc;
            }
        }
    }
    .popup {
        border-top: 1px solid $border-color;
        .btn {
            display: flex;
            justify-content: space-between;
            padding: 0.2rem 0.2rem 0;
            .text {
                border: 0;
                background-color: transparent;
                // outline: none;
            }
        }
    }
}

</style>
